import { createContext } from 'react';

const JobContext = createContext(null);

export default JobContext;
